export const SHORTS_OG_IMAGE_WIDTH = 1200;
export const SHORTS_OG_IMAGE_HEIGHT = 630;
export const SHORTS_OG_IMAGE_TYPE = 'image/jpeg';

const SHORTS_THUMB_CDNS = ['hls', 'hls-staging'] as const;
const SHORTS_THUMB_PREFIXES = [
	'portal-property-showcase',
	'crm-property-showcase'
] as const;

export type ShortsThumbCdn = (typeof SHORTS_THUMB_CDNS)[number];
export type ShortsThumbPrefix = (typeof SHORTS_THUMB_PREFIXES)[number];

export interface ShortsThumbRef {
	cdn: ShortsThumbCdn;
	prefix: ShortsThumbPrefix;
	id: string;
	version: string;
	file: string;
}

const ID_PATTERN = /^[A-Za-z0-9]{1,32}$/;
const VERSION_PATTERN = /^[A-Za-z0-9-]{1,64}$/;
const FILE_PATTERN = /^thumb(?:-[a-z0-9]+){0,3}$/;

const THUMB_URL_PATTERN =
	/^https:\/\/(hls(?:-staging)?)\.pilarhomes\.com\.br\/([^/?#]+)\/([^/?#]+)\/([^/?#]+)\/([^/?#]+)\.webp(?:\?[^#]*)?$/;

function isShortsThumbCdn(value: string): value is ShortsThumbCdn {
	return (SHORTS_THUMB_CDNS as readonly string[]).includes(value);
}

function isShortsThumbPrefix(value: string): value is ShortsThumbPrefix {
	return (SHORTS_THUMB_PREFIXES as readonly string[]).includes(value);
}

export function toShortsThumbRef(
	cdn: string | undefined,
	prefix: string | undefined,
	id: string | undefined,
	version: string | undefined,
	file: string | undefined
): ShortsThumbRef | null {
	if (!cdn || !prefix || !id || !version || !file) return null;
	if (!isShortsThumbCdn(cdn) || !isShortsThumbPrefix(prefix)) return null;
	if (
		!ID_PATTERN.test(id) ||
		!VERSION_PATTERN.test(version) ||
		!FILE_PATTERN.test(file)
	) {
		return null;
	}
	return { cdn, prefix, id, version, file };
}

export function parseShortsThumbUrl(
	url: string | null | undefined
): ShortsThumbRef | null {
	if (!url) return null;
	const match = THUMB_URL_PATTERN.exec(url);
	if (!match) return null;
	return toShortsThumbRef(match[1], match[2], match[3], match[4], match[5]);
}

export function buildShortsThumbUrl({
	cdn,
	prefix,
	id,
	version,
	file
}: ShortsThumbRef): string {
	return `https://${cdn}.pilarhomes.com.br/${prefix}/${id}/${version}/${file}.webp`;
}

export function buildShortsOgImagePath({
	cdn,
	prefix,
	id,
	version,
	file
}: ShortsThumbRef): string {
	return `/og/shorts/${cdn}/${prefix}/${id}/${version}/${file}.jpg`;
}
